import type * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'

import * as common from '../../../common'

export const TRANSFORMER = graphql.transformers.IN.nonNull(
  graphql.transformers.IN.object<
    ents.extra.rate.gl.Rule.Updates,
    graphql.schema.RateRuleUpdates
  >({
    filter: common.gql.filters.inputs.filter.TRANSFORMER,
    isActive: transformers.PASS_THROUGH,
    mapping: common.gql.mappings.inputs.mapping.TRANSFORMER,
    name: transformers.PASS_THROUGH,
    priority: transformers.PASS_THROUGH,
  }),
)
